import { useAppSelector } from "../../hooks/StoreHooks";

export const useWalletTypes = () =>
  useAppSelector((state) => state.walletTypes.walletTypes);
